import React, { useEffect, useState } from "react";

import { get } from "../../services/api";
import { APP_RELEASE } from "../../utils/appVersion";

/**
 * "Uniflo 1.0.1 (build 1755)".
 *
 * Renders the bundle's own stamp immediately, then prefers the server's
 * /healthz release block once it answers. The two carry the same marketing
 * version and the same GitHub commit (the server serves this bundle), but only
 * the server can resolve the integer build number on a Railway deployment,
 * where the build has no Git history.
 */
export default function AppVersionLabel({ className, prefix = "Uniflo" }) {
  const [release, setRelease] = useState(APP_RELEASE);

  useEffect(() => {
    let cancelled = false;
    get("/healthz")
      .then((data) => {
        const live = data?.release;
        if (!cancelled && live?.version && live?.label) setRelease(live);
      })
      .catch(() => {
        // The bundle's own stamp is already on screen; a failed probe changes nothing.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      className={className}
      data-testid="app-version"
      data-version={release.version}
      data-build={release.buildNumber || undefined}
      data-commit={release.gitShortSha || undefined}
      title={release.displayVersion}
    >
      {prefix ? `${prefix} ` : ""}
      {release.label}
    </div>
  );
}
